import React, {useState} from 'react';
import TemporarilyClosedInfoModal from "../components/Modal/TemporarilyClosedInfoModal";

const useTemporarilyClosedInfo = () => {
    const [show, setShow] = useState<boolean>(false);

    const handleShowTemporarilyClosedInfo = () => {
        setShow(true);
    }

    const drawTemporarilyClosedInfo = () => {
        if (show) return <TemporarilyClosedInfoModal show onHide={() => setShow(false)} />
    }

	return {
        handleShowTemporarilyClosedInfo,
        drawTemporarilyClosedInfo
    }
}

export default useTemporarilyClosedInfo;